export default __webpack_public_path__ + "static/integration_works-5237790cb77a19d92e65771fdc513655.png";